import React from "react";
import "./DragHandle.scss";

/**
 * Drag Handle Component
 * Shows a draggable handle icon that appears on hover
 */
const DragHandle = ({ dragHandleProps, isDragging = false, isVisible = true }) => {
  if (!isVisible) return null;

  return (
    <div
      className={`drag-handle d-flex align-items-center justify-content-center mx-2 flex-shrink-0 ${isDragging ? "dragging" : ""}`}
      {...dragHandleProps}
      title='Drag to reorder'>
      <div className='drag-handle-icon'>⋮⋮</div>
    </div>
  );
};

export default DragHandle;
